import React from 'react';

const ColourKey = () => (
  <div className="imy-colour-key">
    <h2>Colour Key: </h2>
    <ul>
      <li className="col-md-12 col-6 colour-key-item colour-key--validimy">Valid (Not Expired) - W-8IMY</li>
      <li className="col-md-12 col-6 colour-key-item colour-key--valid">Valid (Not Expired) - Non W-8IMY</li>
      <li className="col-md-12 col-6 colour-key-item colour-key--invalid">Invalid/Expired</li>
      <li className="col-md-12 col-6 colour-key-item colour-key--initial">Initial Review</li>
      <li className="col-md-12 col-6 colour-key-item colour-key--secondary">Secondary/Expert Review</li>
      <li className="col-md-12 col-6 colour-key-item colour-key--unknown">Unknown Recipient</li>
    </ul>
  </div>
);

export default ColourKey;
